type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
  light?: boolean;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref = "#top",
  light = false,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <div className="flex items-center gap-2">
          <span
            className={`w-6 h-[3px] rounded-full ${
              light ? "bg-accent-400" : "bg-primary-500"
            }`}
          ></span>
          <span
            className={`font-label text-xs tracking-widest ${
              light ? "text-background-300" : "text-foreground-500"
            }`}
          >
            {eyebrow}
          </span>
        </div>
        <h2
          className={`font-heading font-black text-2xl md:text-3xl mt-3 ${
            light ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {desc && (
          <p
            className={`text-sm mt-2 max-w-2xl ${
              light ? "text-secondary-200" : "text-foreground-600"
            }`}
          >
            {desc}
          </p>
        )}
      </div>
      {actionLabel && (
        <a
          href={actionHref}
          className={`inline-flex items-center gap-1 text-sm whitespace-nowrap cursor-pointer transition-colors ${
            light
              ? "text-accent-300 hover:text-accent-200"
              : "text-primary-600 hover:text-primary-700"
          }`}
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line"></i>
        </a>
      )}
    </div>
  );
}